module.exports = __webpack_public_path__ + "static/gradus_3.91d33156.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gradus_3.jpg
// module id = ./src/images/gradus_3.jpg
// module chunks = 221374088121123